<template>
    <form-accordion
        name="transaction-financials"
        section="Transaction Financials"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <purchase-price
            :read_only="read_only"
        />

        <earnest-money-who
            :deal="deal"
            :read_only="read_only"
        />

        <earnest-money-total-due
            :deal="deal"
            :total_due="total_due"
            @updateAmount="total_due = $event"
            :read_only="read_only"
        />

        <earnest-money-initial
            :deal="deal"
            :initial_amount="initial_amount"
            :initial_date_received="initial_date_received"
            @updateAmount="initial_amount = $event"
            @updateDateRecieved="initial_date_received = $event"
            :read_only="read_only"
        />

        <earnest-money-balance
            :deal="deal"
            :balance_amount="formatMoney(balance_amount)"
            :balance_date_received="balance_date_received"
            @updateDateRecieved="balance_date_received = $event"
            :read_only="read_only"
        />

        <earnest-money-held
            :total_held="formatMoney(total_held)"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import DateFunctions from '../../mixins/date-functions.js';
import MoneyFunctions from '../../mixins/money-functions.js';
import PurchasePrice from './purchase-price.vue';
import EarnestMoneyWho from './earnest-money-who.vue';
import EarnestMoneyTotalDue from './earnest-money-total-due.vue';
import EarnestMoneyInitial from './earnest-money-initial.vue';
import EarnestMoneyBalance from './earnest-money-balance.vue';
import EarnestMoneyHeld from './earnest-money-held.vue';

export default {
    mixins: [
        DateFunctions,
        MoneyFunctions,
    ],

    components: {
        PurchasePrice,
        EarnestMoneyWho,
        EarnestMoneyTotalDue,
        EarnestMoneyInitial,
        EarnestMoneyBalance,
        EarnestMoneyHeld,
    },

    props: {
        url: {},
        closed: { default: true },
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            total_due: this.deal.total_earnest_money,
            initial_amount: this.deal.initial_earnest_money,
            initial_date_received: this.deal.initial_earnest_date_received,
            balance_date_received: this.deal.balance_earnest_date_received,
        }
    },

    computed: {
        balance_amount() {
            return this.total_due
                ? (this.moneyVal(this.total_due) - this.moneyVal(this.initial_amount) || 0)
                : null;
        },
        has_initial_date_received() {
            return this.isValidDate(this.initial_date_received);
        },
        has_balance_date_received() {
            return this.isValidDate(this.balance_date_received);
        },
        initial_for_total() {
            return this.initial_amount && this.has_initial_date_received
                ? this.initial_amount
                : 0;
        },
        balance_for_total() {
            return this.balance_amount && this.has_balance_date_received
                ? this.balance_amount
                : 0;
        },
        total_held() {
            return (this.moneyVal(this.initial_for_total) + this.moneyVal(this.balance_for_total)) || null;
        },
    },
}
</script>
